import React from "react";

import { Box, Button, IconButton, Slider, Tooltip } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";

import { DEFAULT_ZOOM_LEVEL } from "../../constants";

interface ZoomProps {
  zoomLevel: number;
  onZoomChange: (zoom: number) => void;
}

export default function Element({ zoomLevel, onZoomChange }: ZoomProps) {
  const handleZoomIn = () => {
    if (zoomLevel < 5) {
      onZoomChange(zoomLevel + 0.1);
    }
  };

  const handleZoomOut = () => {
    if (zoomLevel > 0.1) {
      onZoomChange(zoomLevel - 0.1);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Tooltip title="Zoom out">
        <IconButton size="small" onClick={handleZoomOut}>
          <ZoomOutIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Slider
        size="small"
        min={0.1}
        max={5}
        step={0.1}
        value={zoomLevel}
        onChange={(_, value) => onZoomChange(value as number)}
        aria-label="Timeline zoom"
        sx={{ width: 110, mx: 0.5 }}
      />
      <Tooltip title="Zoom in">
        <IconButton size="small" onClick={handleZoomIn}>
          <ZoomInIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Button
        size="small"
        onClick={() => onZoomChange(DEFAULT_ZOOM_LEVEL)}
        sx={{
          minWidth: 0,
          px: 1,
          ml: 0.5,
          textTransform: "none",
          fontWeight: 600,
          color: "text.secondary",
          border: 1,
          borderColor: "divider",
          borderRadius: 1.5,
          "&:hover": { color: "text.primary", borderColor: "text.secondary" },
        }}
      >
        Fit
      </Button>
    </Box>
  );
}
